const formTypes = {
    NORMAL: "normal",
    DISPOSITION: "disposition",
}

export default formTypes;